/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';
import { FormattedMessage } from 'react-intl';

/* Components */
import CatalogAll from '../../../components/CatalogAll/CatalogAll';

function MyListContainer({
  cardsPerRow, items, isMyListEmpty, onCardArrowPress, myListCommonTagEvent,
}) {
  return isMyListEmpty
    ? (
      <div className="dtv-html5-c-my-list__empty_message">
        <h2 className="dtv-html5-c-my-list__empty_message__title">
          <FormattedMessage id="myList.empty.title" />
        </h2>
        <p className="dtv-html5-c-my-list__empty_message__subtitle">
          <FormattedMessage id="myList.empty.subtitle" />
        </p>
      </div>
    )
    : (
      <CatalogAll
        className="dtv-html5-c-my-list__cards-container"
        cardsPerRow={cardsPerRow}
        items={items}
        onCardArrowPress={onCardArrowPress}
        focusFirstCard
        myListCommonTagEvent={myListCommonTagEvent}
      />
    );
}

MyListContainer.propTypes = {
  cardsPerRow: PropTypes.number,
  items: PropTypes.instanceOf(List),
  isMyListEmpty: PropTypes.bool,
  onCardArrowPress: PropTypes.func,
  myListCommonTagEvent: PropTypes.func,
};

MyListContainer.defaultProps = {
  cardsPerRow: 0,
  items: [],
  isMyListEmpty: true,
  onCardArrowPress: undefined,
  myListCommonTagEvent: undefined,
};

export default memo(MyListContainer);
